/**
 * Component to display net profit and settlement status
 */

import React from 'react';
import { Box, Typography, Divider, Alert } from '@mui/material';
import { formatCurrency } from '../../../utils/formatters';

interface ProfitSummaryProps {
  netProfit: number;
  isSettled: boolean;
  onStartEdit: () => void;
}

export const ProfitSummary: React.FC<ProfitSummaryProps> = ({
  netProfit,
  isSettled,
  onStartEdit: _onStartEdit, // For future use - clickable to edit
}) => {
  return (
    <Box>
      <Divider sx={{ my: 2 }} />

      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Net Profit (This Date)
        </Typography>
        <Typography
          variant="h4"
          sx={{
            typography: { xs: 'h5', sm: 'h4' },
            color: netProfit >= 0 ? 'statusText.ready' : 'statusText.attention',
            fontWeight: 'bold',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap',
          }}
        >
          {formatCurrency(netProfit)}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      {isSettled ? (
        <Alert severity="success">
          This date has been settled. All financial transactions are complete.
        </Alert>
      ) : (
        <Alert severity="info">
          This date has not been settled yet. Financial data is still being finalized.
        </Alert>
      )}
    </Box>
  );
};
